module.exports = __webpack_public_path__ + "media/images/area/feature/setouchi/03-5d1af78554aed95cb12b60a11d8f0d6a.jpg";